export function Lighting() {
  return (
    <>
      <ambientLight intensity={0.55} color="#fffbe6" />
      <directionalLight position={[3, 4, 5]} intensity={1.1} color="#fff5d6" castShadow={false} />
      <directionalLight position={[-4, 2, -3]} intensity={0.45} color="#a8c5ff" />
      <hemisphereLight args={['#f5efe2', '#1a1614', 0.25]} />
    </>
  )
}
